import { createStore, createEvent } from 'effector';

export const $userData = createStore({});

export const setUserData = createEvent();

$userData
    .on(setUserData, (_, value) => value);